import { EventName, mixTrack } from '@services/mixpanel';
import { LegacyWorkoutFormValues } from '../../workout/models/workoutEdit.model';
import { AutoplayTemplates_TabataAndHiitEvent } from '@services/mixpanel/events';

type WorkoutType = 'Tabata' | 'HIIT' | 'Both';

interface Exercise {
  type?: number;
}

interface TrackWorkoutParams {
  workout: LegacyWorkoutFormValues;
  eventName: TrackableEvent;
  workoutId: number;
}

type TrackableEvent = Extract<
  EventName,
  | 'Autoplay Template Published'
  | 'Autoplay Template Saved'
  | 'Autoplay Template Scheduled'
>;

export const detectWorkoutType = (
  workout: LegacyWorkoutFormValues,
): WorkoutType | null => {
  if (!workout.exercises?.length) return null;

  const hasTabata = workout.exercises.some((ex: Exercise) => ex?.type === 10);
  const hasHIIT = workout.exercises.some((ex: Exercise) => ex?.type === 11);

  if (hasTabata && hasHIIT) return 'Both';
  if (hasTabata) return 'Tabata';
  if (hasHIIT) return 'HIIT';
  return null;
};

const trackWorkout = ({
  workout,
  eventName,
  workoutId,
}: TrackWorkoutParams) => {
  const type = detectWorkoutType(workout);
  if (!type) return;

  mixTrack({
    type: eventName,
    payload: { type, workoutId },
  } as AutoplayTemplates_TabataAndHiitEvent);
};

export const trackWorkoutEvent = (
  workout: LegacyWorkoutFormValues,
  workoutId: number,
) => {
  if (!workout.publishedAt)
    return trackWorkout({
      workout,
      eventName: 'Autoplay Template Saved',
      workoutId,
    });

  const published = new Date(workout.publishedAt);
  const now = new Date();
  const diffInMinutes = (now.getTime() - published.getTime()) / (1000 * 60);

  if (diffInMinutes < 10)
    return trackWorkout({
      workout,
      eventName: 'Autoplay Template Scheduled',
      workoutId,
    });

  return trackWorkout({
    workout,
    eventName: 'Autoplay Template Published',
    workoutId,
  });
};
